import { BaseMethod } from "./_Base";
import { Vector2 } from "three";
export class CopResExpression extends BaseMethod {
  constructor() {
    super(...arguments);
    this._requireDependency = true;
    this._resolution = new Vector2();
  }
  static requiredArguments() {
    return [
      ["string", "path to node"],
      ["string", "component_name: x or y"]
    ];
  }
  findDependency(index_or_path) {
    return this.createDependencyFromIndexOrPath(index_or_path);
  }
  async processArguments(args) {
    if (args.length == 1 || args.length == 2) {
      const index_or_path = args[0];
      const component_name = args[1];
      const container = await this.getReferencedNodeContainer(index_or_path);
      if (container) {
        const resolution = container.resolution();
        if (component_name) {
          if ([0, "0", "x"].includes(component_name)) {
            return resolution[0];
          } else {
            if ([1, "1", "y"].includes(component_name)) {
              return resolution[1];
            }
          }
        } else {
          this._resolution.set(resolution[0], resolution[1]);
          return this._resolution;
        }
      }
    }
    return -1;
  }
}
